import React, {
  FocusEventHandler,
  useCallback,
  useState,
  FocusEvent
} from 'react';
import { Tooltip } from 'antd';
import cn from 'classnames';
import styled from 'styled-components';

import { Hint } from './Hint';

type Props = {
  children:
    | React.ReactElement
    | ((args: {
        floating?: boolean;
        onFocus?: FocusEventHandler;
        onBlur?: FocusEventHandler;
      }) => React.ReactElement);
  label: React.ReactNode;
  value: unknown;
  className?: string;
  onFocus?: FocusEventHandler;
  onBlur?: FocusEventHandler;
  error: string | undefined;
  required?: boolean;
  hint?: string;
  noFloat?: boolean;
};

/**
 * @deprecated
 */
function FormControl({
  children,
  className,
  value,
  label,
  onBlur,
  onFocus,
  error,
  required,
  hint,
  noFloat
}: Props) {
  const [floating, setFloating] = useState(false);

  const handleFocus = useCallback(
    (e: FocusEvent) => {
      if (noFloat) return;
      onFocus?.(e);
      setFloating(true);
    },
    [noFloat, onFocus]
  );

  const handleBlur = useCallback(
    (e: FocusEvent) => {
      if (noFloat) return;
      onBlur?.(e);
      setFloating(false);
    },
    [noFloat, onBlur]
  );
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    (<label
      className={cn(className, {
        floating:
          floating ||
          ((Array.isArray(value)
            ? value.length > 0
            : value || (!value && value === 0)) &&
            !noFloat),
        noFloat
      })}
    >
      <span className={cn('label')}>
        {label}
        {hint && <Hint hint={hint} />}
        {required && <sup>*</sup>}
      </span>
      {typeof children === 'function'
        ? children({ floating, onFocus, onBlur })
        : React.cloneElement(React.Children.only(children), {
            onFocus: handleFocus,
            onBlur: handleBlur
          })}
      <Tooltip open={!!error} color="red" title={error} destroyTooltipOnHide>
        <span className="tooltip-anchor" />
      </Tooltip>
    </label>)
  );
}

/**
 * @deprecated
 */
export default styled(FormControl)`
  position: relative;
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;

  .label {
    position: absolute;
    top: 1em;
    left: 0;
    line-height: 1em;
    transition: all 0.25s;
    transform-origin: left top;
    display: flex;
    align-items: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
    display: inline-block;
  }

  &.floating {
    .label {
      top: -5px;
      font-size: 11px;
      opacity: 0.5;
    }
  }
  &.noFloat {
    .label {
      position: static;
    }
  }
  .tooltip-anchor {
    display: block;
    position: absolute;
    bottom: 10px;
    height: 1px;
    z-index: -1;
    width: 100%;
  }
  sup {
    color: red;
  }

  .hint {
    position: relative;
    top: -2px;
    color: var(--primary-color);
    font-size: 1.1em;
    margin-left: 0.5em;
  }
`;
